import { i18N } from "../helper";
const NAME = 'wc_usage';
AC_SERVICES.addListener('Editing.Editables.Ready', (Editables) => {
    const Abstract = Editables.get('_abstract');
    class Usage extends Abstract {
        getEditableType() {
            return NAME;
        }
        focus() {
            this.getLimitElement().focus();
        }
        valueToInput(value) {
            if (value) {
                this.getLimitElement().value = value.usage_limit;
                this.getUserLimitElement().value = value.usage_limit_per_user;
                this.getProductLimitElement().value = value.usage_limit_products;
            }
        }
        getValue() {
            return {
                usage_limit: this.getLimitElement().value,
                usage_limit_per_user: this.getUserLimitElement().value,
                usage_limit_products: this.getProductLimitElement().value
            };
        }
        getLimitElement() {
            return this.getElement().querySelector('[name=limit]');
        }
        getUserLimitElement() {
            return this.getElement().querySelector('[name=user_limit]');
        }
        getProductLimitElement() {
            return this.getElement().querySelector('[name=product_limit]');
        }
        getTemplate() {
            const limit = this.getEditableTemplate().getFormHelper().input('limit', null, { type: 'number' }).outerHTML;
            const use_limit = this.getEditableTemplate().getFormHelper().input('user_limit', null, { type: 'number' }).outerHTML;
            const use_product = this.getEditableTemplate().getFormHelper().input('product_limit', null, { type: 'number' }).outerHTML;
            return `	
				<div class="input__group">
					<label>${i18N().usage_limit_per_coupon}</label>
					<div class="input__controlgroup">${limit}</div>
				</div>
				<div class="input__group">
					<label>${i18N().usage_limit_per_user}</label>
					<div class="input__controlgroup">${use_limit}</div>
				</div>
				<div class="input__group">
					<label>${i18N().usage_limit_products}</label>
					<div class="input__controlgroup">${use_product}</div>
				</div>	
			`;
        }
    }
    Editables.registerEditable(NAME, Usage);
});
// Register MiddleWare
AC_SERVICES.addListener('Editing.Middleware.Ready', (Middleware) => {
    const Abstract = Middleware.getClass('_abstract');
    class Usage extends Abstract {
        getEditable() {
            return this.Editables.get(NAME);
        }
    }
    Middleware.register(NAME, Usage);
});
